import PageHeader from "../common/pageHeader/v2";
import TermsCondition from "../components/section/termsCondition";

const TermsConditionPage = () => {
  return (
    <>
      <PageHeader title="terms & condition" subTitle="terms & condition" />
      <TermsCondition />
    </>
  );
};

export default TermsConditionPage;
